import { render } from "./ERC20.vue?vue&type=template&id=4a687f00"
import script from "./ERC20.vue?vue&type=script&lang=js"
export * from "./ERC20.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__